import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "place-self-center"
}
const _hoisted_2 = {
  key: 0,
  class: "w-full text-3xl"
}
const _hoisted_3 = {
  key: 1,
  class: "w-full text-3xl"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }




export default /*@__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
    horizontal: { type: Boolean },
    customText: {},
    noPendingText: { type: Boolean },
    xl: { type: Boolean },
    xs: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (props.xl)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["grid place-content-center grid-cols-1 gap-4 m-auto text-darkGray-2", __props.horizontal && 'grid-cols-[auto,1fr] gap-4 justify-items-center'])
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "place-self-center fas fa-circle-notch fa-spin text-5xl" }, null, -1)),
        (!__props.noPendingText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (props.customText)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(props.customText), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_3, "Laddar..."))
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : (props.xs)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["grid place-items-center", 
      __props.horizontal &&
      !__props.noPendingText &&
      'grid-cols-[auto,1fr] gap-2 justify-items-center'
    ])
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-circle-notch animate-spin text-base" }, null, -1)),
          (!__props.noPendingText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (props.customText)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.customText), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_6, "Laddar..."))
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["grid place-items-center", __props.horizontal && 'grid-cols-[auto,1fr] gap-2 justify-items-center'])
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-circle-notch animate-spin text-2xl" }, null, -1)),
          (!__props.noPendingText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (props.customText)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(__props.customText), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_9, "Laddar..."))
              ]))
            : _createCommentVNode("", true)
        ], 2))
}
}

})